import React, { Component } from 'react';
//Checked
export default class view extends Component {
	constructor(props) {
		super(props);
		this.state = {
			gerd: null
		};
	}
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>Is the Enteral formula being prescribed an infant formula for lactose intolerance, a severe food allergy or Gastroesophageal Reflux Disease (GERD) that is not responding to an added rice formula?</p>
				<div className="toggle">
					<div className={this.state.gerd === true ? 'Selected' : 'NotSelected'} onClick={(e) => { this.setState({ gerd: true }) }}>Yes</div>
					<div className={this.state.gerd === false ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('InbornMetabolic', false); this.setState({ gerd: false }) }}>No</div>
				</div>
				<div className="button" onClick={() => this.props.navigate(this.state.gerd === true ? 'R5' : 'R30')}>Continue</div>
			</div>
		);
	}
}